<template>
  <q-input :model-value="modelValue" filled class="input-piece" dense v-on:keyup="$emit('update:modelValue', parseInt($event.target.value))" :disable="disabled">
    <template v-slot:prepend>
      <q-btn icon="remove" class="q-mr-xs" size="sm" color="primary" unelevated @click="decrease" dense :disable="disabled" />
    </template>
    <template v-slot:append>
      <q-btn icon="add" size="sm" color="primary" unelevated @click="increase" dense :disable="disabled" />
    </template>
  </q-input>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'InputPiece',

  props: {
    modelValue: {
      default: 1,
      required: true,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
  },

  methods: {
    increase() {
      this.$emit('update:modelValue', this.modelValue + 1);
    },
    decrease() {
      this.$emit('update:modelValue', this.modelValue - 1);
    },
  },

  watch: {
    /**
     * Adet girişini sadece numara olarak al
     */
    modelValue(val) {
      let value = val;
      if (val < 1 || isNaN(val + 1)) {
        value = 1;
      }
      this.$emit('update:modelValue', parseInt(value));
    },
  },
});
</script>

<style scoped>
.input-piece ::v-deep(input) {
  font-weight: 700;
  font-family: system-ui, -apple-system, sans-serif;
}

.input-piece ::v-deep(input) {
  width: 40px;
  text-align: center;
}
</style>
